interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
  strokeWidth?: number;
  showDot?: boolean;
  className?: string;
}

const Sparkline = ({
  data,
  width = 120,
  height = 36,
  stroke = "#6366f1",
  fill = "rgba(99, 102, 241, 0.12)",
  strokeWidth = 1.5,
  showDot = true,
  className = "",
}: SparklineProps) => {
  if (data.length === 0) {
    return (
      <svg width={width} height={height} className={className}>
        <line
          x1="0"
          y1={height / 2}
          x2={width}
          y2={height / 2}
          stroke="#e4e4e7"
          strokeWidth="1"
          strokeDasharray="2 3"
        />
      </svg>
    );
  }

  const padding = 2;
  const w = width - padding * 2;
  const h = height - padding * 2;

  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;

  const stepX = data.length > 1 ? w / (data.length - 1) : 0;

  const points = data.map((d, i) => {
    const x = padding + i * stepX;
    const y = padding + h - ((d - min) / range) * h;
    return [x, y] as const;
  });

  const pathD = points
    .map(([x, y], i) => `${i === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`)
    .join(" ");

  const areaD =
    pathD +
    ` L ${(padding + (data.length - 1) * stepX).toFixed(2)} ${(padding + h).toFixed(2)} L ${padding} ${(padding + h).toFixed(2)} Z`;

  const lastPoint = points[points.length - 1];
  const gradId = `sparkGrad-${Math.random().toString(36).slice(2, 7)}`;

  return (
    <svg width={width} height={height} className={className}>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity={0.22} />
          <stop offset="100%" stopColor={stroke} stopOpacity={0} />
        </linearGradient>
      </defs>
      <path d={areaD} fill={`url(#${gradId})`} />
      <path
        d={pathD}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {showDot && lastPoint && (
        <>
          <circle
            cx={lastPoint[0]}
            cy={lastPoint[1]}
            r="2.5"
            fill={stroke}
          />
          <circle
            cx={lastPoint[0]}
            cy={lastPoint[1]}
            r="6"
            fill={stroke}
            fillOpacity="0.2"
            className="animate-ping-slow"
          />
        </>
      )}
    </svg>
  );
};

export default Sparkline;
